import { useQuery } from '@tanstack/react-query';
import type { ExplorerData } from './types';

export const QUERY_KEYS = {
  explorerList: ['lifecycle-v2', 'explorer', 'list'] as const,
};

export function useExplorerData() {
  return useQuery<ExplorerData>({
    queryKey: QUERY_KEYS.explorerList,
    queryFn: async () => {
      const res = await fetch('/api/v2/lifecycle/explorer/list');
      if (!res.ok) throw new Error('Erreur chargement des données');
      return res.json() as Promise<ExplorerData>;
    },
  });
}
